import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth, firestore } from '../config/db'; // Your Firebase config
import { signInWithEmailAndPassword } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // Store user data
  const [loading, setLoading] = useState(true); // Handle loading state
  const [error, setError] = useState(null); // Handle error messages
  const navigate = useNavigate();

  // Check if user is already in localStorage when app starts
  useEffect(() => {
    const savedUser = JSON.parse(localStorage.getItem('user'));
    if (savedUser) {
      setUser(savedUser); // Set user from localStorage
      if (savedUser.authenticated) {
        navigate('/admin'); // If authenticated, navigate to admin page
      }else if (savedUser.authenticated === false){
        alert("Użytkownik nie został zatwierdzony przez administratora!")
        console.log("Użytkownik nie został zatwierdzony przez administratora!")
      }
    }
    setLoading(false);
  }, [navigate]);

  const login = async (email, password) => {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
  
      const userDocRef = doc(firestore, 'users', user.uid);
      const userDoc = await getDoc(userDocRef);
  
      if (userDoc.exists()) {
        const userData = userDoc.data();
        setUser({ ...userData, uid: user.uid });
  
        // Check authentication status
        if (userData.authenticated) {
          // Save the user data in localStorage if authenticated
          localStorage.setItem('user', JSON.stringify({ ...userData, uid: user.uid }));
          navigate('/admin');
        } else {
          setError('Administrator nie zatwierdził twojego konta');
        }
      } else {
        setError('Nie znaleziono dokumentu użytkownika');
      }
    } catch (error) {
      setError('Błędny email lub hasło'); // Customize error for invalid credentials
    } finally {
      setLoading(false);
    }
  };
  
  const logout = async () => {
    await auth.signOut();
    setUser(null);
    localStorage.removeItem('user'); // Remove user data from localStorage
    navigate('/adminlogin');
  };

  const isAuthenticated = !!user && user.authenticated;

  return (
    <AuthContext.Provider value={{ user, isAuthenticated, login, logout, error }}>
      {!loading ? children : <div>Loading...</div>}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
